import { render, staticRenderFns } from "./AIDialog.vue?vue&type=template&id=0a804b48&scoped=true&"
import script from "./AIDialog.vue?vue&type=script&lang=js&"
export * from "./AIDialog.vue?vue&type=script&lang=js&"
import style0 from "./AIDialog.vue?vue&type=style&index=0&id=0a804b48&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a804b48",
  null
  
)

export default component.exports